let intervalInfo;
let clearCartIntervalInfo;
export const checkUserActivity = maxInactivity => {
  let secondsSinceLastActivity = 0;
  clearInterval(intervalInfo);
  intervalInfo = setInterval(() => {
    secondsSinceLastActivity++;
    postMessage({ isUserInactive: secondsSinceLastActivity > Number(maxInactivity) });
  }, 1000);
};

export const clearCartItem = (cartCount, dailyCartStatusCheckFlag, clearCartTime, isLocalized) => {
  const yesterdayDate = new Date(dailyCartStatusCheckFlag);
  clearInterval(clearCartIntervalInfo);

  if (!clearCartIntervalInfo && cartCount > 0) {
    clearCartIntervalInfo = setInterval(() => {
      const todaysDate = new Date();
      const currentTime = new Date().getHours();
      const isTrue =
        currentTime >= Number(clearCartTime) &&
        todaysDate.getDate() !== yesterdayDate.getDate() &&
        cartCount > 0 &&
        isLocalized;
      postMessage({ isCartClear: isTrue });
    }, 1000);
  }
};
